module.exports = __webpack_public_path__ + "static/media/03.3bc234b7.jpg";